import { render } from "./WorkerKnowledgeTypes.vue?vue&type=template&id=483b3a01&scoped=true"
import script from "./WorkerKnowledgeTypes.vue?vue&type=script&lang=js"
export * from "./WorkerKnowledgeTypes.vue?vue&type=script&lang=js"

import "./WorkerKnowledgeTypes.vue?vue&type=style&index=0&id=483b3a01&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483b3a01"]])

export default __exports__